var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoProyecto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185,
    height: 189,
    viewBox: "0 0 185 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke: #b53f16;\r\n        stroke-width: 5px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #b53f16;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fffffd;\r\n        font-size: 30px;\r\n        font-family: JamesFajardo, James Fajardo;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #bf4916;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #db6020;\r\n      }\r\n\r\n      .cls-6 {\r\n        stroke: none;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(-1374.356 -80.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    className: "cls-1",
    transform: "translate(1374.356 80.711)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 92.5,
    cy: 94.5,
    rx: 92.5,
    ry: 94.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 92.5,
    cy: 94.5,
    rx: 90,
    ry: 92
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(1403.821 140.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    className: "cls-2",
    d: "M120.771,331.638H5.3a5.317,5.317,0,0,1-5.3-5.3V299.058a5.316,5.316,0,0,1,5.3-5.3h115.47a5.316,5.316,0,0,1,5.3,5.3v27.279a5.317,5.317,0,0,1-5.3,5.3",
    transform: "translate(0 -254.733)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Santa_Clara",
    "data-name": "Santa Clara",
    className: "cls-3",
    transform: "translate(17.164 68.671)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Santa Clara")), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    className: "cls-4",
    d: "M13.018,233.563c4.537,0,6.868,2.912,6.868,8.012v1H15.477v-1.323c0-2.274-.849-3.139-2.332-3.139s-2.331.865-2.331,3.139c0,6.557,9.115,7.785,9.115,16.89,0,5.1-2.373,8.01-6.955,8.01s-6.95-2.913-6.95-8.01v-1.959h4.409v2.277c0,2.272.931,3.094,2.416,3.094s2.415-.821,2.415-3.094c0-6.556-9.114-7.786-9.114-16.887,0-5.1,2.332-8.012,6.869-8.012",
    transform: "translate(-2.119 -233.563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    className: "cls-5",
    d: "M46.013,265.985h-4.7l-.806-5.78H34.78l-.8,5.78H29.692l4.749-31.86h6.826Zm-10.638-10.1h4.493L37.62,239.77Z",
    transform: "translate(-10.443 -233.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    className: "cls-4",
    d: "M62.94,260.116,66.5,234.124h4.283L66.2,265.985H59.252l-4.578-31.861h4.7Z",
    transform: "translate(-19.228 -233.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    className: "cls-5",
    d: "M95.646,265.985H90.94l-.8-5.78H84.414l-.807,5.78H79.325l4.75-31.86H90.9Zm-10.64-10.1H89.5L87.252,239.77Z",
    transform: "translate(-27.898 -233.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    className: "cls-4",
    d: "M111.967,242.911v23.074h-4.2V234.124h5.853l4.79,19.073V234.124h4.154v31.861h-4.79Z",
    transform: "translate(-37.901 -233.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    className: "cls-4",
    d: "M139.889,242.911v23.074h-4.2V234.124h5.85l4.788,19.073V234.124h4.157v31.861H145.7Z",
    transform: "translate(-47.722 -233.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    className: "cls-5",
    d: "M178.1,265.985H173.4l-.807-5.78h-5.723l-.8,5.78h-4.281l4.747-31.86h6.826Zm-10.639-10.1h4.493l-2.248-16.112Z",
    transform: "translate(-56.897 -233.761)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoProyecto);
export default __webpack_public_path__ + "static/media/Logo_Proyecto.275acf27ddc90bb359d874decc85ac83.svg";
export { ForwardRef as ReactComponent };